import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Fund } from 'src/components/Exchange/types';
import { moduleActions } from 'src/redux/modules';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import {
  getDisplayTradeDate,
  getUserFunds,
} from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import {
  getHasMixedCollegeTypes,
  getOnlyCollegeType,
} from 'src/redux/modules/productTypes/productType.selectors';
import { getCollegeAvailableFundList } from 'src/redux/modules/shoppingCart/collegeShoppingCart.selectors';
import {
  getHiddenAccountNumber,
  getIsCorporateAccountType,
  getNonRetirementMaxLimit,
  getUserFundList,
} from 'src/redux/modules/shoppingCart/shoppingCart.selectors';
import { getPersonalInformationData } from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import { ADD_FUND_MODAL_PROPS } from 'src/settings/settings';
import ExpandedFundList from '../../Buy/BuyFlow/ExpandedFundList/ExpandedFundList';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import CollegeContributeFundEditor from '../CollegeContributeFundEditor/CollegeContributeFundEditor';
import CollegeContributeFundGroupHeader from '../CollegeContributeFundGroupHeader/CollegeContributeFundGroupHeader';
import CollegeFundListActionBarLink from './CollegeFundListActionBarLink';

export const CollegeContributeFundList = ({
  actions,
  quickBuy,
  currentStep,
}) => {
  const availableFunds = useSelector(getCollegeAvailableFundList);
  const displayTradeDate = useSelector(getDisplayTradeDate);
  const isCorporateAccountType = useSelector(getIsCorporateAccountType);
  const hasMixedCollegeTypes = useSelector(getHasMixedCollegeTypes);
  const hiddenAccountsNumber = useSelector(getHiddenAccountNumber);
  const nonRetirementMaxLimit: number = useSelector(getNonRetirementMaxLimit);
  const onlyCollegeType = useSelector(getOnlyCollegeType);
  const personalData = useSelector(getPersonalInformationData);
  const selectedBank = useSelector(getSelectedBank);
  const userFunds = useSelector(getUserFunds);
  const userFundsList: Fund[] = useSelector(getUserFundList);

  const showAddNewFundOrAccount =
    selectedBank &&
    (!selectedBank.sameDayBank || selectedBank.externallyVerifiedBank);

  const fundListActionBarModalProps =
    ADD_FUND_MODAL_PROPS[
      hasMixedCollegeTypes ? 'MIXED_COLLEGE' : `${onlyCollegeType}_COLLEGE`
    ];

  return (
    <StepExpanded>
      <ExpandedFundList
        canAddNewFund
        actions={actions}
        availableFunds={availableFunds}
        currentStep={currentStep}
        currentYearInclusiveRemainingContributions={nonRetirementMaxLimit + 1}
        displayTradeDate={displayTradeDate}
        fundEditor={() => CollegeContributeFundEditor}
        fundGroupHeader={CollegeContributeFundGroupHeader}
        fundListActionBarLink={CollegeFundListActionBarLink}
        fundListActionBarModalProps={fundListActionBarModalProps}
        hiddenAccountsNumber={hiddenAccountsNumber}
        isCorporateAccountType={isCorporateAccountType}
        isFullyContributedIRA={false}
        nonRetirementMaxLimit={nonRetirementMaxLimit}
        numberOfFunds={userFundsList.length}
        personalData={personalData}
        priorYearInclusiveRemainingContributions={0}
        quickBuy={quickBuy}
        showAddNewFundOrAccount={showAddNewFundOrAccount}
        userFunds={userFunds}
      />
    </StepExpanded>
  );
};

const mapStateToProps = (state) => {
  const { quickBuy } = state;
  return {
    quickBuy,
    // TODO: Remove temporary executeCollegeContribute placeholder
    executeCollegeContribute: {
      isLoaded: false,
      transactions: [],
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollegeContributeFundList);
